<main #simulatorContainer class="simulator" aria-label="Simulador de Comissionamento">
  <header class="simulator-header">
    <div class="header-controls" aria-label="Filtros do período">
      <app-exercise-calendar
        [initialYear]="selectedYear"
        [initialMonth]="selectedMonth"
        [disableEvenMonths]="true"
        (periodChange)="onPeriodChange($event)">
      </app-exercise-calendar>
      <app-export-document-button
        [disabled]="isExporting"
        [initialStartYear]="selectedYear"
        [initialStartMonth]="selectedMonth"
        [initialEndYear]="selectedYear"
        [initialEndMonth]="selectedMonth"
        (exportDirect)="onExportRequested()"
        class="export-button">
      </app-export-document-button>
      <button
        class="mode-control"
        type="button"
        [disabled]="isExporting"
        aria-label="Mostrar ou ocultar a matriz Penetration/ISR"
        aria-controls="penetration-table"
        [attr.aria-expanded]="isPenetrationVisible"
        (click)="togglePenetrationTable()">
        Penetration/ISR
      </button>
    </div>
  </header>

  <div class="dashboard-grid">
    <section class="panel realized-panel">
      <div class="panel-heading realized-heading">
        <div class="panel-heading-copy">
          <h2 class="panel-title">
            Realizado do dealer
            <span
              class="tooltip-trigger"
              role="img"
              tabindex="0"
              aria-label="Tooltip Realizado: Abra a sessão para verificar o resultado médio do período real DN"
              aria-describedby="realized-tooltip">
              <span class="info-icon" aria-hidden="true">i</span>
              <span class="realized-tooltip" id="realized-tooltip" aria-hidden="true">
                Abra a sessão para verificar o resultado médio do período real DN
              </span>
            </span>
          </h2>
          <p class="panel-subtitle">Resultado médio do período real DN</p>
        </div>
      </div>

      <div class="table-scroll">
        <table class="realized-table">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">Novos</th>
              <th scope="col">Usados</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            @for (row of realizedRows; track row.label) {
              <tr>
                <th scope="row">{{ row.label }}</th>
                <td>{{ row.newVehicles }}</td>
                <td>{{ row.usedVehicles }}</td>
                <td>{{ row.total }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>

    <section class="panel closing-panel">
      <div class="panel-heading">
        <div class="panel-heading-copy">
          <h2 class="panel-title">Dados para fechar o período</h2>
          <p class="panel-subtitle">Campos editáveis (% ou vol)</p>
        </div>
        <button
          class="edit-control"
          type="button"
          [attr.aria-label]="isEditing ? 'OK: confirmar alterações e calcular' : 'Editar dados do período'"
          [attr.title]="isEditing ? 'OK: confirmar alterações e calcular' : 'Editar dados do período'"
          [attr.aria-pressed]="isEditing"
          (click)="toggleEditing()">
          @if (!isEditing) {
            <svg viewBox="0 0 16 16" aria-hidden="true">
              <path d="m2.5 11.5-.7 2.7 2.7-.7L13 5a1.9 1.9 0 0 0-2.7-2.7l-7.8 9.2Z"></path>
              <path d="m9.4 3.2 3.4 3.4"></path>
            </svg>
          } @else {
            <svg viewBox="0 0 16 16" aria-hidden="true">
              <path d="m3 8 3.2 3.2L13 4.5"></path>
            </svg>
          }
        </button>
      </div>

      <div class="table-scroll">
        <table class="closing-table">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">Novos</th>
              <th scope="col">Usados</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            @for (row of visibleClosingPeriodRows; track row.label) {
              <tr>
                <th scope="row">{{ row.label }}</th>
                @for (value of [row.newVehicles, row.usedVehicles, row.total]; track $index) {
                  <td>
                    @if ($index < 2 && !row.totalEditable && value !== '') {
                      <span class="closing-input-shell" [class.input-updated]="isInputUpdated(row, $index === 0 ? 'newVehicles' : 'usedVehicles')">
                        <input
                          class="closing-input"
                          type="text"
                          inputmode="decimal"
                          [value]="value"
                          [readOnly]="!isEditing"
                          [attr.aria-label]="row.label + ' - ' + ($index === 0 ? 'Novos' : 'Usados')"
                          (input)="updateClosingInput(row, $index === 0 ? 'newVehicles' : 'usedVehicles', $event)">
                        @if (row.inputType === 'percentage') {
                          <span class="input-suffix" aria-hidden="true">%</span>
                        }
                      </span>
                    } @else if ($index === 2 && row.totalEditable) {
                      <span class="closing-input-shell" [class.input-updated]="isInputUpdated(row, 'total')">
                        <input
                          class="closing-input"
                          type="text"
                          inputmode="decimal"
                          [value]="value"
                          [readOnly]="!isEditing"
                          [attr.aria-label]="row.label + ' - Total'"
                          (input)="updateClosingInput(row, 'total', $event)">
                        @if (row.inputType === 'percentage') {
                          <span class="input-suffix" aria-hidden="true">%</span>
                        }
                      </span>
                    } @else {
                      {{ value }}
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>

    <section class="panel new-period-panel">
      <div class="panel-heading">
        <div class="panel-heading-copy">
          <h2 class="panel-title">Novo período</h2>
          <p class="panel-subtitle">Resultado do novo período</p>
        </div>
      </div>

      <div class="table-scroll">
        <table class="new-period-table">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">Novos</th>
              <th scope="col">Usados</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            @for (row of newPeriodRows; track row.label) {
              <tr>
                <th scope="row">{{ row.label }}</th>
                <td>{{ row.newVehicles }}</td>
                <td>{{ row.usedVehicles }}</td>
                <td>{{ row.total }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>

    <footer class="commission-summary" aria-label="Resumo de comissão">
      <div class="summary-item">
        <span class="summary-label">Média Regional</span>
        <strong>
          {{ regionalAverageDisplay }}
          @if (regionalTrend) {
            <span
              class="trend"
              [class.trend-up]="regionalTrend.direction === 'up'"
              [class.trend-down]="regionalTrend.direction === 'down'">
              {{ regionalTrend.direction === 'up' ? '↑' : '↓' }} {{ regionalTrend.value }}
            </span>
          }
        </strong>
      </div>
      <div class="summary-item">
        <span class="summary-label">Média Nacional</span>
        <strong>
          {{ nationalAverageDisplay }}
          @if (nationalTrend) {
            <span
              class="trend"
              [class.trend-up]="nationalTrend.direction === 'up'"
              [class.trend-down]="nationalTrend.direction === 'down'">
              {{ nationalTrend.direction === 'up' ? '↑' : '↓' }} {{ nationalTrend.value }}
            </span>
          }
        </strong>
      </div>
      <div class="summary-total">
        <span class="summary-eyebrow">COMISSÃO TOTAL</span>
        <strong>{{ totalCommission }}</strong>
      </div>
    </footer>
    <span class="visually-hidden" aria-live="polite">{{ updateFeedbackMessage }}</span>
  </div>

  @if (isPenetrationVisible) {
    <section class="panel penetration-panel" id="penetration-table" aria-labelledby="penetration-title">
      <h2 class="panel-title" id="penetration-title">Penetration/ISR</h2>
      <div class="penetration-table-scroll" [attr.aria-busy]="isPenetrationLoading">
        @if (isPenetrationLoading || !hasPenetrationData) {
          <div class="matrix-status" role="status">
            @if (isPenetrationLoading) {
              <span class="matrix-loader" aria-hidden="true"></span>
              <span>Carregando matriz...</span>
            } @else {
              <span>Nenhum dado de matriz encontrado para este DN/período. Exibindo tabela provisória.</span>
            }
          </div>
        }
        <table class="penetration-table">
          <thead>
            <tr>
              <th scope="col">Penet / ISR</th>
              @for (column of penetrationColumns; track column) {
                <th scope="col">{{ column }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of penetrationRows; track row.label) {
              <tr>
                <th scope="row">{{ row.label }}</th>
                @for (value of row.values; track $index) {
                  <td>{{ value }}</td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  }
</main>

<app-export-download-modal
  [show]="showExportModal"
  [fileName]="exportFileName"
  [fileBlob]="exportFileBlob"
  [emailSubject]="exportEmailSubject"
  [emailBody]="exportEmailBody"
  (close)="showExportModal = false"
  (download)="handleExportModalDownload()">
</app-export-download-modal>
